import { z } from "zod";
import { DocTypeSchema } from "./enums.js";

/** Indexed file attached to a candidate. `storage_key` is internal and never exposed. */
export const DocumentSchema = z.object({
  id: z.uuid(),
  candidateId: z.uuid(),
  fileName: z.string(),
  contentType: z.string(),
  byteSize: z.number().int(),
  docType: DocTypeSchema,
  version: z.number().int(),
  uploadedAt: z.string(),
});
export type Document = z.infer<typeof DocumentSchema>;
